export const generativeAiContent = {
    bannerContent: {
        shortHeading: "Generative AI Development Services",
        mainHeading: "At the Forefront of <span>Enterprise</span> Transformation With Generative AI",
        description: "Empower your business with best generative AI development services designed to optimize workflows & boost innovation. By working with a leading generative AI development company, you gain intelligent solutions that increase efficiency, scalability, & measurable growth across industries.",
    },
    whyUsContent: {
        shortHeading: "Why Bitsclan",
        heading: " Company Preferred by Clients Across the Globe",
        greenHeading: "A Generative AI",
        image: "/images/generative-ai-why-us.png",
        content: "We create custom Generative AI solutions that drive business value. Trusted for reliable, high-performing GenAI services, we transform challenges into measurable opportunities with proven technology & expertise.",
        stats: [
            {
                title: "AI Services Since",
                number: "2017"
            },
            {
                title: "GenAI Projects",
                number: "180+"
            },
            {
                title: "GenAI Engineers",
                number: "100+"
            },
            {
                title: "GenAI Solutions Across Industries",
                number: "14+"
            },
        ]
    },
    testimonialData: {
        shortHeading: "GenAI Client Reviews",
        mainHeading: "Client <span>Success</span> Stories That Speak for Themselves",
        description: "Our clients trust Bitsclan for innovative Generative AI solutions. Hear how our services helped them achieve better accuracy, efficiency, & growth in their industries.",
        testimonials: [
            {
                name: "Michael Turner",
                enterprise: "Enterprise Automation",
                country: "Austin, US",
                countryFlagImage: "/images/testimonials/flags/usa-flag.png",
                designation: "CTO at BrightPath Logistics",
                profileImage: "/images/testimonials/michael.avif",
                logoImage: "/images/logo-2.png",
                text: "Bitsclan built a chatbot that now handles most of our customer queries. Response times are down to seconds, & our support team is free to focus on complex issues. It’s been a huge boost to efficiency & customer satisfaction.",
                serviceTags: [
                    { title: "Chat bots & Virtual Agents", link: "/ai-chatbot-development-services" },
                    { title: "AI Automation", link: "/ai-automation-agency" },
                    { title: "Generative AI", link: "/generative-ai-development-services" }
                ]
            },
            {
                name: "Sophie Keller",
                enterprise: "Healthcare AI",
                country: "Florida, US",
                countryFlagImage: "/images/testimonials/flags/usa-flag.png",
                designation: "Head of Digital Transformation at Meditech Solutions",
                profileImage: "/images/testimonials/sophie.avif",
                logoImage: "/images/logo-2.png",
                text: "With Bitsclan’s agentic AI, we’ve automated routine admin tasks like scheduling & reporting. Our staff now spends more time with patients, & errors have dropped noticeably. The solution fit right into our workflow.",
                serviceTags: [
                    { title: "Chat bots & Virtual Agents", link: "/ai-chatbot-development-services" },
                    { title: "AI Automation", link: "/ai-automation-agency" },
                    { title: "Generative AI", link: "/generative-ai-development-services" }
                ]
            },
            {
                name: "Sarah Coleman",
                enterprise: "Construction & Industrial Equipment",
                country: "Illinois, US",
                countryFlagImage: "/images/testimonials/flags/usa-flag.png",
                designation: "Training & Product Specialist at American Moisture Test",
                profileImage: "/images/testimonials/sarah.avif",
                logoImage: "/images/testimonials/logo-amt.png",
                text: "Partnering with Bitsclan allowed us to digitize our testing workflow. From product tracking to client reporting, everything is now managed in one unified system. The team’s industrial understanding and precision execution exceeded our expectations.",
                serviceTags: [
                    { title: "Custom Web Development", link: "/custom-software-development-services" },
                    { title: "Equipment Management System", link: "#" },
                    { title: "ERP Integration", link: "#" }
                ]
            }
        ]
    },
    caseStudyContent: {
        shortHeading: "GenAI Case Studies",
        heading: "From Innovation to Impact: Proven Results With <span>Generative AI</span>",
        description: "Discover how Bitsclan’s Generative AI services transform client challenges into measurable results, delivering real business impact & innovative solutions that drive growth & efficiency."
    },
    generativeAiServices: {
        heading: "From <span>Automation</span> to Creation: Generative AI Solutions That Scale",
        shortHeading: "Generative AI Services",
        description: "",
        cardsData: [
            {
                title: "Generative AI Consulting",
                description: "Unlock the true potential of AI with tailored strategies. Through our Generative AI Consulting, we assess workflows, recommend suitable models, & design adoption plans that maximize ROI. With expertise in NLP, ML, & automation, we deliver scalable, cost-effective, high-impact AI solutions."
            },
            {
                title: "Generative AI Rapid Prototyping",
                description: "At Bitsclan, we quickly build functional Generative AI prototypes to validate your idea. Our tailored POCs showcase real impact, proving feasibility & laying the groundwork for future growth, smarter solutions, & innovation across your business journey."
            },
            {
                title: "Generative AI Model Replication",
                description: "Looking for an AI model that works like ChatGPT, DeepSeek, Perplexity, Claude & more? Our GenAI expert developers build scalable, high-performing solutions using advanced NLP & NLU techniques, delivering reliable generative AI models customized to your business needs."
            },
            {
                title: "Generative AI & GPT Integration",
                description: "Bitsclan integrates generative AI & GPT models into CRMs, ERPs & cloud systems with no disruption. Our customized solutions improve workflows with intelligent text generation, automated summarizations & personalized user experiences, allowing organizations to drive efficiency with AI powered operations."
            },
            {
                title: "AI-Powered Image & Text Generation",
                description: "Our AI-based tools can generate images & written content in seconds so your business can save money & time. Because your business can produce high-quality images & text at scale, you will benefit from increased efficiency & easily accomplish all of your projects quickly!"
            },
            {
                title: "Custom Generative AI Development",
                description: "As an AI services company, we specialize in developing custom generative AI solutions for your needs. From chatbots to recommendation systems, we develop innovative generative AI tools using foundational models like GPT-4, LLaMA, & PaLM 2. These models can transform complex challenges into opportunities."
            },
            {
                title: "Generative AI Model Fine-Tuning",
                description: "We fine-tune pre-trained generative AI models using your data so that we can train new models with greater accuracy & relevance. Our process accommodates & aligns with your brand, voice & audience, allowing for a smarter & more personalized AI solution for your business requirements."
            },
            {
                title: "Generative AI Upgrades & Support",
                description: "We not only provide maintenance & upgrades to your generative AI systems, but we also ensure optimal performance, compliance, & innovation. Our team maintains your AI solutions & ensures the performance is updated so you can receive long-term success in your business."
            }
        ]
    },
    trendingInsights: {
        heading: "Strategic Insights & Resources on Generative AI",
        description:
            "Discover valuable Generative AI development resources & insights, offering practical guidance, industry updates, & expert knowledge to help businesses innovate, streamline operations, & unlock growth with cutting-edge GenAI technologies.",
    },
    roadmapContent: {
        shortHeading: "GenAI Development Roadmap",
        heading: "From <span>Concept</span> to Deployment: GenAI Solutions in Just 4 Weeks",
        description: "From concept to deployment, our Generative AI expertise delivers secure, reliable, & future-ready solutions, empowering businesses with innovation, efficiency, & measurable impact through scalable GenAI systems tailored to diverse industries.",
        processData: [
            {
                title: "Requirement Analysis & Data Preparation",
                description:
                    "We begin by understanding client needs, identifying data sources, & preparing clean datasets for training. This ensures the foundation for accurate & reliable Generative AI development.",
                icon: "/images/roadmap-icons/platform-evaluation.svg"
            },
            {
                title: "Model Design & Training",
                description:
                    "Our team designs the AI architecture, trains the model with advanced algorithms, & evaluates its accuracy, efficiency, & overall performance through rigorous testing.",
                icon: "/images/roadmap-icons/Training-LLM-Fine-Tuning.svg"
            },
            {
                title: "Fine-Tuning & Optimization",
                description:
                    "The trained AI model is refined & optimized to boost precision, reliability, & scalability, ensuring it aligns perfectly with the client’s business goals.",
                icon: "/images/roadmap-icons/development-strategy.svg"
            },
            {
                title: "Deployment & Continuous Support",
                description:
                    "The final GenAI solution is seamlessly integrated into existing systems, followed by ongoing monitoring, upgrades, & maintenance for long-term performance.",
                icon: "/images/roadmap-icons/Development.svg"
            },
        ],
        cta: {
            text: "Schedule a Call With GenAI Expert",
            link: "https://calendly.com/bitsclan-it/30min?"
        }
    },
    faqSection: {
        heading: "What Enterprises Need to Know About Generative AI",
        questionAnswers: [
            {
                id: "collapseOne",
                question: "How generative AI benefits my business?",
                answer:
                    "Generative AI offers multiple advantages in the form of automated processes, improved efficiency, & streamlined operations. Beyond internal operations, it also elevates customer interactions, creating more personalized & engaging brand experiences.",
            },
            {
                id: "collapseTwo",
                question: "Why work with a generative AI services company?",
                answer:
                    "Partnering with a generative AI services company ensures expert support at every stage. Bitsclan identifies high-impact opportunities & integrates AI seamlessly into your existing systems & workflows.",
            },
            {
                id: "collapseThree",
                question: "How do Gen AI development services help rapid prototyping?",
                answer:
                    "With Gen AI, rapid prototyping is about generating & testing AI model formulations quickly to identify what’s going to work for your purposes. Rapid prototyping is a way to test, change, & refine before you commit to a full solution. Ultimately, a working prototype is going to save time & mitigate risk.",
            },
            {
                id: "collapseFour",
                question: "How does GenAI enhance the software development process?",
                answer:
                    "GenAI makes software development better by automating code generation, detecting errors early, & providing recommendations for improvements. It also enables easier prototyping, improved testing, & smarter, faster, more efficient development cycles.",
            },
            {
                id: "collapseFive",
                question: "How can generative AI tools benefit a product development team?",
                answer:
                    "Generative AI tools help product development teams accelerate ideation, create prototypes faster, optimize designs, & simulate scenarios. They enhance creativity, reduce errors, & improve decision-making for efficient, innovative product development.",
            },
            {
                id: "collapseSix",
                question: "What is the cost to create & integrate a generative AI solution?",
                answer:
                    "Like with every custom solution, the costs associated with generative AI projects will vary based on many factors like complexity of the project, level of expertise of the resources involved, amount of technology engaged, etc. To get a firm quote, you can share your requirements with us, & we will share with you an estimated price.",
            },
        ]
    },
    companyCta: {
        heading: "Curious about how Generative AI can Benefit you? Let’s chat!",
        // subHeading: "See how our expert developers can help.",
        buttonText: "Contact us Now",
    },
    generativeAiIntigration: {
        heading: "From GPT to Claude: Models That Enable Intelligent Enterprise Solutions",
        cardsData: [
            {
                title: "AI WhatsApp Chatbot",
                icon: "/images/workflow-images/workflow-icons/ai-whatsapp.svg"
            },
            {
                title: "AI Telegram Chatbot",
                icon: "/images/workflow-images/workflow-icons/ai-telegram.svg"
            },
            {
                title: "AI Facebook Chatbot",
                icon: "/images/workflow-images/workflow-icons/ai-facebook.svg"
            },
            {
                title: "AI Instagram Chatbot",
                icon: "/images/workflow-images/workflow-icons/ai-instagram.svg"
            },
            {
                title: "AI Website Chatbot",
                icon: "/images/workflow-images/workflow-icons/ai-website.svg"
            },
            {
                title: "AI WordPress Chatbot",
                icon: "/images/workflow-images/workflow-icons/ai-wordpress.svg"
            },
            {
                title: "Voice enabled Chatbots",
                icon: "/images/workflow-images/workflow-icons/voice-enable.svg"
            },
            {
                title: "AI Sales Agent",
                icon: "/images/workflow-images/workflow-icons/ai-sales-agent.svg"
            },
            {
                title: "AI Marketing Agent",
                icon: "/images/workflow-images/workflow-icons/ai-marketing.svg"
            },
            {
                title: "AI Voice Assistant Apps",
                icon: "/images/workflow-images/workflow-icons/ai-voice-assistent.svg"
            },
            {
                title: "AI Shopping Agent",
                icon: "/images/workflow-images/workflow-icons/ai-shopping.svg"
            },
            {
                title: "AI Customer Support Agent",
                icon: "/images/workflow-images/workflow-icons/ai-customer.svg"
            }
        ]
    }
};